// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {LoginType, Permissions, SimRole, SimUser, UserCalendarFeedAccessToken} from "@models";
import {Translations} from "@translations";
import {
	SimConfigurationService,
	SimSystemService,
	SimUserCalendarFeedService,
	SimUserExtendedService,
	SimUtilityExtendedService,
	SimMaterialDialogService,
} from "@services";
import Enumerable from "linq";

export interface DialogData_UserCard extends MatDialogDataBaseInput {
	userData: UserCardUserData;
}

export interface UserCardUserData extends Partial<SimUser> {
	firstname: string;
	lastname: string;
}

@Component({
	selector: "sim-user-card-mat-dialog",
	templateUrl: "./user-card-mat-dialog.component.html",
	styleUrls: ["./user-card-mat-dialog.component.scss"],
	standalone: false,
})
export class UserCardMatDialogComponent extends BasicMaterialDialog<UserCardMatDialogComponent, DialogData_UserCard> implements OnInit {
	LoginType = LoginType;
	T = Translations;
	roleName: string;
	simRoles: SimRole[] = [];
	calendarAccessTokens: UserCalendarFeedAccessToken[] = [];
	public permissionToChangeOwnPassword: boolean = false;

	constructor(
		_injector: Injector,
		public userService: SimUserExtendedService,
		private _simSystemService: SimSystemService,
		private _userCalendarFeedService: SimUserCalendarFeedService,
		private _utilityService: SimUtilityExtendedService,
		private _config: SimConfigurationService,
		private _simDialogService: SimMaterialDialogService,
	) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();

		this._simSystemService.getSimRoles().then((response) => {
			this.simRoles = response;
		});

		this._userCalendarFeedService.getFeedAccessTokensForCurrentUser().then((response) => {
			this.calendarAccessTokens = response;
		});

		this.permissionToChangeOwnPassword = this.userService.hasPermission(Permissions.UserManagement_PermissionToChangeOwnPassword);
	}

	asUserData(): UserCardUserData {
		return;
	}

	getRoleNames(roleIds: string[]): string[] {
		return Enumerable.from(this.simRoles)
			.where((r) => roleIds?.includes(r.id))
			.select((r) => r.name)
			.toArray();
	}

	copyToClipboard(token: UserCalendarFeedAccessToken) {
		const baseUrl = document.location.origin;
		const feedUrl = baseUrl + token.feedUrl;
		this._utilityService.copyToClipBoard(feedUrl);
	}

	createNewCalendarAccessToken() {
		this._userCalendarFeedService.generateFeedAccessToken().then((response) => {
			this.calendarAccessTokens.push(response);
		});
	}

	deleteCalendarAccessToken(token: UserCalendarFeedAccessToken) {
		this._userCalendarFeedService
			.deleteFeedAccessToken({
				tokenId: token.id,
			})
			.then((response) => {
				this.calendarAccessTokens = this.calendarAccessTokens.filter((t) => t.id !== token.id);
			});
	}

	changePassword(value) {
		this._simDialogService.openChangePasswordDialog({
			userForPasswordChange: value,
		});
	}
}
